import { render } from "./taxes-modal.vue?vue&type=template&id=10915394"
import script from "./taxes-modal.vue?vue&type=script&lang=js"
export * from "./taxes-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__